import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '../../../../../styles';
import { getLiteral } from 'utils/getLiteral';

import FuzzySearchAutoCompleteFM from '../../../FuzzySearch';
import styles from './styles';

import {
    defaultMapStateToProps,
    defaultMapDispatchToProps,
    mapfuzzySearchStateToProps,
} from '../redux';
import {
    UserChip,
    CompanyChipNoClick as CompanyChip,
    OpportunityChipNoClick as OpportunityChip,
    ContactChipNoClick as ContactChip,
    ChipSizes,
} from '../../../../../components/chip';

function mapStateToProps(state, ownProps) {
    let entity = state.crud.entityCrud;
    let id;
    let desc;
    if (ownProps.field.standard) {
        id = entity.get(ownProps.field.id.id.toLowerCase());
        desc = entity.get(ownProps.field.id.desc.toLowerCase());
    } else {
        let extraField = entity.get(ownProps.field.id.toLowerCase());
        id = extraField !== null ? extraField.value : null;
        desc = extraField !== null ? extraField.description : null;
    }
    return {
        ...defaultMapStateToProps(state, ownProps),
        ...mapfuzzySearchStateToProps(state, ownProps),
        id: id,
        desc: desc,
    };
}

const propTypes = {
    styles: PropTypes.string.isRequired,
    field: PropTypes.object.isRequired,

    error: PropTypes.string,
    mandatory: PropTypes.bool,
    description: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
    hidden: PropTypes.bool,
    id: PropTypes.string,
    desc: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
};

const GetEntityValueList = (styles, valueListName, desc, id, onCancel, readOnly) => {
    switch (valueListName) {
        case 'Empresas':
            return readOnly ? (
                <CompanyChip style={styles.text} id={id} name={desc} size={ChipSizes.SMALL} />
            ) : (
                <CompanyChip
                    clearStyle={styles.clearStyle}
                    styleTitle={styles.titleStyle}
                    style={styles.selected}
                    id={id}
                    name={desc}
                    onCancel={onCancel}
                    size={ChipSizes.SMALL}
                />
            );

        case 'Expedientes':
            return readOnly ? (
                <OpportunityChip style={styles.text} id={id} name={desc} size={ChipSizes.SMALL} />
            ) : (
                <OpportunityChip
                    styleTitle={styles.titleStyleOpportunity}
                    clearStyle={styles.clearStyle}
                    style={styles.selected}
                    id={id}
                    name={desc}
                    onCancel={onCancel}
                    size={ChipSizes.SMALL}
                />
            );

        case 'viewUsuariosFullName':
            return readOnly ? (
                <UserChip style={styles.text} id={id} name={desc} size={ChipSizes.SMALL} />
            ) : (
                <UserChip
                    clearStyle={styles.clearStyle}
                    styleTitle={styles.titleStyle}
                    style={styles.selected}
                    id={id}
                    name={desc}
                    onCancel={onCancel}
                    size={ChipSizes.SMALL}
                />
            );

        case 'contacts':
            return readOnly ? (
                <ContactChip style={styles.text} id={id} name={desc} size={ChipSizes.SMALL} />
            ) : (
                <ContactChip
                    clearStyle={styles.clearStyle}
                    styleTitle={styles.titleStyle}
                    style={styles.selected}
                    id={id}
                    name={desc}
                    onCancel={onCancel}
                    size={ChipSizes.SMALL}
                />
            );

        case 'viewContactosFullName':
            return readOnly ? (
                <ContactChip style={styles.text} id={id} name={desc} size={ChipSizes.SMALL} />
            ) : (
                <ContactChip
                    clearStyle={styles.clearStyle}
                    styleTitle={styles.titleStyle}
                    style={styles.selected}
                    id={id}
                    name={desc}
                    onCancel={onCancel}
                    size={ChipSizes.SMALL}
                />
            );

        default:
            return undefined;
    }
};

// seems we are using only on Billing and RatesManagement
@connect(mapStateToProps, defaultMapDispatchToProps)
@withStyles(styles)
class CrudFuzzySearch extends Component {
    onChange = (item, index, data) => {
        let { onChange, onRemove, field } = this.props;
        if (index !== -1) {
            field.standard
                ? onChange(field.id.id, data.get(index).Id, data.get(index), data.get(index))
                : onChange(
                      field.id,
                      { value: data.get(index).Id, description: data.get(index).MatchingInfo },
                      data.get(index),
                  );
            field.standard && onChange(field.id.desc, data.get(index).MatchingInfo);
        } else {
            onRemove(field.id.id);
            field.standard && onRemove(field.id.desc);
        }
    };

    _onCancel = () => {
        let { onRemove, id, desc, field } = this.props;
        field.standard ? onRemove(field.id.id) : onRemove(field.id);
        field.standard && onRemove(field.id.desc);
    };

    renderChip = () => {
        let { desc, field, onCancel, styles, id, readOnly } = this.props;
        return GetEntityValueList(styles, field.valueListName, desc, id, this._onCancel, readOnly);
    };

    renderAutoComplete = () => {
        let {
            styles,
            field,
            id,
            desc,
            hidden,
            readOnly,
            mandatory,
            description,
            error,
            hintText,
            entityDependence,
            entityDependenceId,
            entity,
        } = this.props;
        error = error && error.length !== 0 ? error : '';
        let literalHintText = 'action_searchcompany';
        if (entity) {
            switch (entity) {
                case 'products':
                    literalHintText = 'action_searchproduct';
                    break;
                case 'companies':
                    literalHintText = 'action_searchcompany';
                    break;
                case 'opportunities':
                    literalHintText = 'action_searchopportunity';
                    break;
                case 'contacts':
                    literalHintText = 'action_search_contact';
                    break;
            }
        }
        return (
            <FuzzySearchAutoCompleteFM
                {...this.props}
                errorText={error}
                disabled={readOnly}
                style={styles.inputStyle}
                inputStyle={styles.inputStyle}
                hintStyle={styles.hintStyle}
                hintText={
                    field.hintText ? field.hintText : <Text>{getLiteral(literalHintText)}</Text>
                }
                searchText={''}
                onSelectItem={this.onChange}
                entityDependence={entityDependence}
                entityDependenceId={entityDependenceId}
                usersFromService={field.usersFromService || ''}
            />
        );
    };

    render() {
        let { styles, field, id, desc, hidden, readOnly, mandatory, description, error } =
            this.props;
        let renderContent = id && desc ? this.renderChip() : this.renderAutoComplete();
        if (hidden || field.hidden) return null;
        return (
            <div style={styles.fieldContainer}>
                <span style={styles.title}>
                    {description} {mandatory ? '*' : ''}
                </span>
                {renderContent}
            </div>
        );
    }
}

CrudFuzzySearch.propTypes = propTypes;

export default CrudFuzzySearch;
